import { useLiveQuery } from "dexie-react-hooks";
import { ExternalStatusRepository } from "../../utils/dexie/repositories/external-status-repository";
import { useState } from "react";
import { Avatar, Box, Chip } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ExternalStatusMultiList = ({
    drop,
    readOnly = true
}) => {
    const [selectedIds,] = useState(drop?.externalStatusIds);

    const selectedExternalStatuses = useLiveQuery(async () => selectedIds != null ? await ExternalStatusRepository.getMultiple(selectedIds) : null, [selectedIds]);
    
    // Remark: we currently only support this component in readonly mode
    const isReadOnly = true; // readOnly || !appParams?.externalStatusManagement;

    if (selectedExternalStatuses == null || selectedExternalStatuses.length === 0)
        return null;

    return (
        <Box style={{display: 'inline-flex', marginBottom: 0, gap: 5}}>
            {selectedExternalStatuses.map(status => (
                <Chip key={status.id} size="small" variant="outlined"
                    clickable={false}
                    label={status.translatedTerm ?? status.name}
                    style={{
                        color: status?.foregroundColor,
                        backgroundColor: status?.backgroundColor ?? 'transparent'
                    }}
                    avatar={
                        !isReadOnly ?
                            <Avatar style={{backgroundColor: status?.foregroundColor ?? '#FFF'}}>
                                <FontAwesomeIcon color={status?.backgroundColor} icon={["fal", "pen"]} />
                            </Avatar> : null
                    }
                />
            ))}
        </Box>
    );

};